import { convertToDisplayDate } from "./date";

interface ExportableLead {
  createdDate?: string;
  name?: string;
  email?: string;
  countryCode?: string;
  phoneNumber?: string;
  interestedCourses?: string;
  identity?: string;
  schoolName?: string;
  studentResult?: string;
  estimatedResult?: string;
  lastTouchedDate?: string;
  // status?: string;
  assignee?: string;
  // courseFinderResult?: {
  //   answers?: {
  //     courseFinderInterests?: unknown;
  //     studentResult?: string;
  //     estimatedResult?: string;
  //   };
  // };
  // courseFinderInterests?: unknown;
  // careerTestResult?: unknown;
  tuition?: {
    subject?: string[];
  };
  SpmTuition?: {
    subject?: string[];
  };
}

const toListText = (value: unknown): string => {
  if (Array.isArray(value)) return value.filter(Boolean).join(", ");
  return typeof value === "string" ? value : "";
};

export const mapLeadToExcelRow = (
  lead: ExportableLead,
  index: number,
): Record<string, unknown> => {
  // const answers = lead.courseFinderResult?.answers || {};
  // const interestedCourses =
  //   lead.interestedCourses ||
  //   toListText(answers.courseFinderInterests) ||
  //   toListText(lead.courseFinderInterests);
  // const hasCourseFinderResult = Boolean(
  //   lead.courseFinderResult ||
  //   (Array.isArray(lead.courseFinderInterests) &&
  //     lead.courseFinderInterests.length) ||
  //   (Array.isArray(answers.courseFinderInterests) &&
  //     answers.courseFinderInterests.length),
  // );

  return {
    No: index + 1,
    "Created Date": convertToDisplayDate(lead.createdDate || ""),
    Name: lead.name || "",
    Email: lead.email || "-",
    Phone: `${lead.countryCode || ""} ${lead.phoneNumber || ""}`,
    Identity: lead.identity || "-",
    // "Interested Courses": interestedCourses,
    "School Name": lead.schoolName || "",
    // "Student Result": lead.studentResult || answers.studentResult || "",
    // "Estimated Result": lead.estimatedResult || answers.estimatedResult || "",
    // "Course Finder": hasCourseFinderResult ? "Completed" : "-",
    // "Career Test": lead.careerTestResult ? "Completed" : "-",
    // "Last Touched": convertToDisplayDate(lead.lastTouchedDate || ""),
    // Status: lead.status || "New",
    Assignee: lead.assignee || "",
    "UEC Subject": toListText(lead.tuition?.subject) || "",
    "SPM Subject": toListText(lead.SpmTuition?.subject) || "",
  };
};
